import styled from 'styled-components';
import AppCSS from '../../../utils/styled';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

export const Components = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 32px;
  `,
  Header: styled.span`
    ${AppCSS.fonts.h3};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  SectionTitle: styled.span`
    ${AppCSS.fonts.h4};
    color: ${AppCSS.colors.blues.veryDark};
    justify-content: start;
  `,
  SubsectionTitle: styled.span`
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.blues.veryDark};
    justify-content: start;
  `,

  ImpersonateButton: styled(AppCSS.buttonStyles.SecondaryButtonStyle)`
    width: 240px;
    ${AppCSS.radiuses.small}
    ${AppCSS.fonts.label12Bold}
    background-color: ${AppCSS.colors.gold};
    color: ${AppCSS.colors.white};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span<{ danger?: boolean }>`
    ${AppCSS.fonts.label12Bold};
    color: ${(p) => (p?.danger ? AppCSS.colors.red : AppCSS.colors.blues.veryDark)}};
  `,
  FieldBasic: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  LinkLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  SearchUserWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,
  SearchButton: styled.label`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,
  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: 10%;
    ${AppCSS.radiuses.small}
  `,
  SecondaryButton: styled(AppCSS.buttonStyles.SecondaryButtonStyle)<{
    destructive?: boolean;
    danger?: boolean;
    large?: boolean;
  }>`
    width: ${(p) => (p?.large ? 240 : 160)}px;
    min-width: ${(p) => (p?.large ? 240 : 160)}px;
    ${AppCSS.radiuses.small}
    ${AppCSS.fonts.label12Bold}
    background-color: ${(p) => (p?.danger ? AppCSS.colors.red : AppCSS.colors.white)};
    color: ${(p) =>
      p?.destructive ? AppCSS.colors.red : p?.danger ? AppCSS.colors.white : AppCSS.colors.blues.veryDark};
  `,

  LengthInputsWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  SearchHeader: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 24px 16px;
    gap: 16px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.boxShadows};
    width: 100%;
  `,
  CheckboxFieldWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    //margin: 12px 0;
  `,

  Checkbox: styled(Checkbox)`
    &.Mui-checked {
      color: ${AppCSS.colors.blues.dark} !important;
    }

    color: ${AppCSS.colors.blues.veryLight};
    width: 20px;
    height: 20px;
  `,
  CheckboxLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
    width: 5%;
  `,

  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
  `,

  LinkAccessWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `,

  Separator: styled.div`
    width: 100%;
    padding: 1px;
    background-color: ${AppCSS.colors.greys.dark};
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,

  FormButtonsContainer: styled.div`
    padding-top: 28px;
    width: 100%;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
};
